import CommonFileUpload from "framework/common/CommonFileUpload";
import React, { useState, useContext } from "react"
import { Row, Col, Button } from "reactstrap"


export const CreditNoteDocumets = ({
    selectedAttachFiles,
    setSelectedAttachFiles,
    attachFileNames,
    setAttachFileNames,
    clearStatus,
    disable,
    clearAttachmentEdit
}) => {

    return (<Row>
        <CommonFileUpload
            selectedAttachFiles={selectedAttachFiles}
            setAttachFileNames={setAttachFileNames}
            attachFileNames={attachFileNames}
            setSelectedAttachFiles={setSelectedAttachFiles}
            clearStatus={clearStatus}
            disable={disable}
            clearAttachmentEdit={clearAttachmentEdit}
        />
    </Row>)

};